
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { INTERNATIONAL_TRADE_LIST } from "@/constant";

import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit,
} from "@/api/proforma";
import { getSuppliersList } from "@/api/inquiry";
import { queryInvoice, createInvoice } from "@/api/booking-order";
import { cal } from "@/utils/cal";

@Component({
  name: "GenerateIV",
  components: {
    ViewProduct: () => import("./ViewProduct.vue"),
  },
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "生成IV" }) private title: "";
  @Prop({ default: "" }) private id: "";

  @Watch("show", { immediate: true })
  private async watchData() {
    if (this.show && this.id) {
      await this.queryInvoice();
    }
  }

  private showProduct = false;

  private ivAccountType = "A";
  private or_amount = 0;
  private form = {
    internationalTradeTerms: null,
    insuranceAmount: null,
    freightAmount: null,
    extrasAmount: null,
  } as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "款项名称",
      prop: "costName",
      key: "costName",
      show: true,
      disabled: false,
      type: "input",
    },
    {
      label: "金额",
      prop: "amount",
      key: "amount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 2,
      min: -9999999
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
      type: "textarea",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  private infoFields = [
    {
      label: "IV号码",
      prop: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      label: "货款结算金额",
      prop: "settlementAmount",
      key: "settlementAmount",
    },
    {
      label: "客人简称",
      prop: "customerAbbreviation",
      key: "customerAbbreviation",
    },
    {
      label: "产品总数量",
      prop: "totalQuantity",
      key: "totalQuantity",
    },
    {
      label: "IV总金额",
      prop: "totalAmount",
      key: "totalAmount",
      account: ['A','A_B'],
    },
    {
      label: "IV销售定价",
      prop: "totalCompanyAmount",
      key: "totalCompanyAmount",
      account: ['B','A_B'],
    },
  ] as any;
  private info = {} as any;
  private list = [
    {
      label: "成交方式",
      prop: "internationalTradeTerms",
      key: "internationalTradeTerms",
      type: "select",
      placeholder: "请选择成交方式",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择成交方式",
        trigger: "change",
      },
      options: INTERNATIONAL_TRADE_LIST,
    },
    {
      label: "保费",
      prop: "insuranceAmount",
      key: "insuranceAmount",
      type: "inputNumber",
      value: "",
      disabled: false,
      placeholder: "请填写保费",
      precision: 2,
    },
    {
      label: "运费",
      prop: "freightAmount",
      key: "freightAmount",
      type: "inputNumber",
      value: "",
      disabled: false,
      placeholder: "请填写运费",
      precision: 2,
    },
    {
      label: "杂费",
      prop: "extrasAmount",
      key: "extrasAmount",
      type: "inputNumber",
      value: "",
      disabled: false,
      precision: 2,
      placeholder: "请填写杂费",
    },
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  //  删除
  public async handleDelete(scope) {
    this.table.list.splice(scope.$index, 1);
    this.info.totalAmount = this.or_amount;
    this.table.list.map((res) => {
      this.info.totalAmount = cal
        .jia(this.info.totalAmount, res.amount)
        .toFixed(2);
    });
    let allNumber = Number(this.form.insuranceAmount?this.form.insuranceAmount:0) + Number(this.form.freightAmount?this.form.freightAmount:0) + Number(this.form.extrasAmount?this.form.extrasAmount:0)
    this.info.totalAmount = (Number(this.info.totalAmount) + allNumber).toFixed(2)
  }

  private handleAdd() {
    // table.list 新增一条记录
    this.table.list.push({
      type: "",
      amount: "",
      remark: "",
    });
  }

  private async submitForm(): Promise<void> {
    await this.createInvoice();
    this.$emit('success');
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.tableCol[1].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private inputChange({ val, row, column }) {
    if (column.key === "amount") {
      this.info.totalAmount = this.or_amount;
      this.table.list.map((res) => {
        this.info.totalAmount = cal
          .jia(this.info.totalAmount, res.amount)
          .toFixed(2);
      });
      let allNumber = Number(this.form.insuranceAmount?this.form.insuranceAmount:0) + Number(this.form.freightAmount?this.form.freightAmount:0) + Number(this.form.extrasAmount?this.form.extrasAmount:0)
      this.info.totalAmount = (Number(this.info.totalAmount) + allNumber).toFixed(2)
    }
  }

  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit,
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit,
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }

  private async createInvoice() {
    let otherPayments = this.table.list.map((item) => {
      return {
        costName: item.costName,
        amount: item.amount,
        remark: item.remark,
      };
    });
    // 判断 costName amount是否为空
    let flag = false;
    otherPayments.forEach((item) => {
      if (!item.costName || !item.amount) {
        flag = true;
      }
    });
    if (flag) {
      this.$message({
        type: "error",
        message: "款项名称和金额不能为空",
      });
      return;
    }
    await createInvoice({
      ...this.form,
      otherPayments,
      bookingOrderId: this.info.bookingOrderId,
      useInvoiceMoney: false,
    });
    this.$message({
      type: "success",
      message: "操作成功",
    });
    this.close();
    this.$emit("success", false);
  }
  public loading: Boolean = false;
  private async queryInvoice() {
    this.loading = true;
    const res: any = await queryInvoice(this.id);
    this.info = res;
    this.or_amount = res.totalAmount;
    Object.keys(this.form).forEach((key) => {
      this.form[key] = res[key];
    });
    this.formUpdate(this.form);
    this.table.list = res.invoiceOtherPaymentList.map((item) => {
      return {
        costName: item.paymentName,
        amount: item.paymentAmount,
        remark: item.remark,
      };
    });
    this.info.totalAmount = this.or_amount;
    this.table.list.map((res) => {
      this.info.totalAmount = cal
        .jia(this.info.totalAmount, res.amount)
        .toFixed(2);
    });
    let allNumber = Number(this.form.insuranceAmount?this.form.insuranceAmount:0) + Number(this.form.freightAmount?this.form.freightAmount:0) + Number(this.form.extrasAmount?this.form.extrasAmount:0)
    this.info.totalAmount = (Number(this.info.totalAmount) + allNumber).toFixed(2)
    this.loading = false;
  }
  private calcflag = false;

  private formUpdate(obj) {
    console.log("保费保费保费")
    if (this.calcflag) {
      this.form.insuranceAmount = null
      this.calcflag = false;
    }
    if (obj.internationalTradeTerms === "2") {
      this.form.insuranceAmount = this.getFee();
      this.calcflag = true;
    }
    if (obj.internationalTradeTerms !== "2") {
      this.list[1].disabled = true;
    } else {
      this.list[1].disabled = false;
    }
    if (obj.internationalTradeTerms === "1") {
      this.list[2].disabled = true;
      this.form.freightAmount = null
    }else{
      this.list[2].disabled = false;
    }
    if (obj.internationalTradeTerms === "4") {
      this.list[1].disabled = false;
    }

    let tableAllNumber = 0;
    this.table.list.map((res) => {
      tableAllNumber = tableAllNumber + res.amount;
    });
    let allNumber = Number(this.form.insuranceAmount?this.form.insuranceAmount:0) + Number(this.form.freightAmount?this.form.freightAmount:0) + Number(this.form.extrasAmount?this.form.extrasAmount:0) + Number(tableAllNumber)
    this.$set(this.info,'totalAmount',(Number(this.info.settlementAmount?this.info.settlementAmount:0) + allNumber).toFixed(2))
  }

  private getFee() {
    let amount = Number(this.info.totalAmount);
    return +cal.cheng(amount, 1.1 * 0.001).toFixed(2);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName,
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
